import { jsx as _jsx } from "react/jsx-runtime";
import useMessageChannel from "../../lib/hooks/use-message-channel";
import DropDownMenu from "../DropDownMenu";
import Icon from "../Icon";
export const EVENT_CHART_ACTION = "chart-action";
export default function ChartOptions(props) {
    const channel = useMessageChannel();
    function onOptionClicked(optionValue) {
        channel.send(EVENT_CHART_ACTION, {
            chartId: props.chartId,
            type: optionValue,
            name: props.name,
        });
    }
    return (_jsx("div", { children: _jsx(DropDownMenu, { sections: [
                {
                    options: [
                        { label: "Download CSV", value: "download-csv" },
                        { label: "Download Image", value: "download-image" },
                    ],
                },
            ], onChange: (MenuOption) => {
                onOptionClicked(MenuOption.value);
            }, customIcon: _jsx(Icon, { name: "cog" }), displayType: "icon", alignRight: true }) }));
}
